/**
 * ドラクエ9 基本乱数生成クラス
 * @class DQ9Rand
 */
class DQ9Rand {
  /**
   * @type {number} 乱数シード
   */
  private _seed: number = 0

  public constructor() {}

  /**
   * 乱数シードのgetter
   * @returns {number} 乱数シード
   */
  public get seed(): number {
    return this._seed
  }

  /**
   * 乱数シードのsetter
   * @param {number} value 乱数シード
   */
  public set seed(value: number) {
    this._seed = value
  }

  /**
   * 乱数生成メソッド
   * @returns {number} 生成された乱数
   */
  public generateRandom(): number {
    const b: bigint = (BigInt(this._seed) * 1103515245n + 12345n) & 0xffffffffn
    this._seed = Number(b)
    return (this._seed >>> 0x10) & 0x7fff
  }
}

export { DQ9Rand }
